import { orderBy, map, extend, find } from 'lodash-es'
import { api } from '@/api'
import to from '@/modules/await-to-js'

const state = {
  customers: {}
}

export const getters = {
  customers: state => orderBy(state.customers.list, ['name'], ['asc'])
}

export const mutations = {
  setCustomers (state, customers) {
    state.customers = customers
  },

  setCustomerFleets (state, { customer, fleets }) {
    customer.fleets = fleets
  },

  setCustomerClusters (state, { customer, clusters }) {
    customer.clusters = clusters
  }
}

export const actions = {
  async getCustomers (context) {
    let error, response
    [error, response] = await to(api.getCustomers(context.rootGetters.application))
    if (error || !response) return

    // Set default or existings fleets/clusters list
    response.data.list = map(response.data.list, (customer) => {
      let fleets, clusters
      // If we already have a customer list, get current fleets/clusters
      if (context.state.customers.list) {
        const stateCustomer = find(context.state.customers.list, cust => cust.id === customer.id)

        if (stateCustomer) {
          fleets = stateCustomer.fleets
          clusters = stateCustomer.clusters
        }
      }

      return extend({}, customer, { fleets: fleets || { totalCount: '-' }, clusters: clusters || { totalCount: '-' } })
    })

    context.commit('setCustomers', response.data)
  },

  // Get customer fleets and attach them to the customer in this store
  async getCustomerAllFleets (context, customer) {
    let error, response
    [error, response] = await to(api.getCustomerAllFleets(customer))

    if (error || !response) {
      context.commit('setCustomerFleets', { customer: customer, fleets: { totalCount: '-', list: [] } })
      return
    }

    context.commit('setCustomerFleets', { customer: customer, fleets: response.data })
  },

  // Get customer clusters and attach them to the customer in this store
  async getCustomerAllClusters (context, customer) {
    let error, response
    [error, response] = await to(api.getCustomerAllClusters(customer))

    if (error || !response) {
      context.commit('setCustomerClusters', { customer: customer, clusters: { totalCount: '-', list: [] } })
      return
    }

    context.commit('setCustomerClusters', { customer: customer, clusters: response.data })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
